import React, { Suspense, lazy } from 'react';
import LoadingScreen from './LoadingScreen';
import ScoreDisplay from './ScoreDisplay';
import GameHeaderControls from './GameHeaderControls';

const LazyDailyChallengeResults = lazy(() => import('./DailyChallengeResults'));
const LazyOverallStats = lazy(() => import('./OverallStats'));

export function CompletedChallenge({
  state,
  handlers,
}: {
  state: any;
  handlers: any;
}) {
  const {
    challengeResultData,
    isTodayChallenge,
    showAllTimeStats,
    restorationLoading,
    challenge,
  } = state;
  const { setShowAllTimeStats, onShowCalendar, onShowInstructions } = handlers;

  return (
    <div className="h-full">
      <div className="ui-box-wrapper flex justify-center items-start md:py-6 h-full">
        <div className="game-ui-card w-full max-w-[668px] bg-[#090312] md:border border-[#322A3F] md:rounded md:mx-4 flex flex-col pb-[50px] md:pb-[90px]">
          <div className="px-4 md:px-6 pb-4 sticky z-20 top-0 bg-[#0a0612] flex justify-between items-center pt-4 h-[72px] border-b border-white/10">
            <ScoreDisplay
              round={0}
              totalRounds={0}
              correctGuesses={challengeResultData.correctGuesses || 0}
              score={challengeResultData.score || 0}
              pointsGained={null}
              onShowInstructions={onShowInstructions}
              gameMode="daily"
              isPastChallenge={!isTodayChallenge}
            />

            <GameHeaderControls
              onShowStats={() => setShowAllTimeStats(true)}
              onShowCalendar={() => {
                onShowCalendar();
                if (typeof window.gtag === 'function') {
                  window.gtag('event', 'open_calendar', {
                    current_view: 'daily',
                  });
                }
              }}
              onShowInstructions={onShowInstructions}
              gameMode="daily"
              hasDailyChallenge={!!challenge}
            />
          </div>

          <Suspense fallback={<LoadingScreen />}>
            <LazyDailyChallengeResults
              stats={challengeResultData.distributionStats}
              roundData={challengeResultData.roundData}
              imageUrls={challengeResultData?.imageUrls || []}
              challengeImages={challenge?.images || []}
              minYear={challengeResultData.minYear}
              maxYear={challengeResultData.maxYear}
              onShowCalendar={onShowCalendar}
              isPastChallenge={!isTodayChallenge}
              challengeDate={challengeResultData.dateCompleted}
              restorationLoading={restorationLoading}
              score={challengeResultData.score}
              averageYearsOff={challengeResultData.averageYearsOff}
              usedHints={challengeResultData.usedHints}
            />
          </Suspense>
        </div>
      </div>

      <Suspense fallback={<LoadingScreen />}>
        {showAllTimeStats && (
          <LazyOverallStats
            onClose={() => setShowAllTimeStats(false)}
            selectedDate={
              challengeResultData.dateCompleted ||
              new Date().toISOString().split('T')[0]
            }
          />
        )}
      </Suspense>
    </div>
  );
}

export default CompletedChallenge;
